import { useGetMeApi } from 'eds-common/api/v2';
import redemptionSuccessBanner from '@/assets/images/redemption-success-banner.jpg';
import { useAccessCodeRedemptionContext } from './AccessCodeRedemptionContext';
import { RedemptionSuccessActions } from './RedemptionSuccessActions';

const TEXT_NUMBERS = [
  '',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
] as const;

export function AutoEntitleRedemptionSuccess() {
  const { redemptionData } = useAccessCodeRedemptionContext();
  const { data: user } = useGetMeApi();

  if (!redemptionData.product) {
    return null;
  }

  const hasSelectedClasses = redemptionData.selectedClassIds.length > 0;
  const classCount = redemptionData.selectedClassIds.length;

  return (
    <div className="flex flex-col">
      <img
        src={redemptionSuccessBanner}
        alt=""
        className="h-[161px] w-full object-cover"
      />
      <h2 className="px-8 pb-4 pt-6 text-3xl font-bold text-neutral-1300">
        Setup complete!
      </h2>
      <div className="mt-8 flex flex-col gap-6 px-8 pb-8 text-lg text-neutral-900">
        <p>
          You now have access to{' '}
          <strong className="font-bold">
            {redemptionData.product.productName}!
          </strong>
        </p>

        {hasSelectedClasses ? (
          <p>
            <strong className="font-bold">
              {classCount > 9 ? classCount : TEXT_NUMBERS[classCount]}
            </strong>{' '}
            of your classes will also have access to this product. This process
            may take a couple of minutes. We&apos;ll let you know if there are
            any problems.
          </p>
        ) : (
          <p>
            <strong className="font-bold">None</strong> of your classes have
            access to this product.{' '}
            {user?.userSource === 'GoogleClassroom'
              ? 'Import your classes from Google Classroom and entitle your students to give them access.'
              : 'Student access can be managed at the class level.'}
          </p>
        )}

        <p>
          {hasSelectedClasses ? 'Students' : 'Once granted, students'} can
          access the product by signing in from the{' '}
          <strong className="font-bold">
            {redemptionData.product.productName}
          </strong>{' '}
          website or the Scholastic Education Platform.
        </p>
      </div>

      <RedemptionSuccessActions />
    </div>
  );
}
